<template>
  <div>
    <div class="columns">
      <div class="column is-one-fifth">
        <p class="has-text-weight-bold is-size-6 mb-sm">Webhook History</p>
        <p class="has-text-grey is-size-7">
          Review recent webhook results.
        </p>
      </div>
      <div class="column">
        <!-- Filters Toolbar -->
        <div class="has-background-white rounded-lg pa-md mb-xxs">
          <div class="columns">
            <div class="column">
              <HistoryFilters :applied-filters="filters" @filter="filter" />
            </div>
            <div class="column is-narrow">
              <b-select v-model="orderBy" size="is-medium" expanded @input="sort">
                <option value="-id">Most Recent</option>
                <option value="id">Oldest</option>
              </b-select>
            </div>
          </div>
        </div>
        <div class="has-background-white rounded-lg">
          <b-table :data="results" :mobile-cards="false" :loading="loading" hoverable class="rounded-lg is-size-7">
            <template>
              <!-- Type -->
              <b-table-column label="ID" cell-class="nowrap has-text-grey-light" width="128" v-slot="props">
                {{ props.row.event.object_id }}
              </b-table-column>
              <!-- Topic -->
              <b-table-column label="Topic" cell-class="nowrap has-text-grey-light" v-slot="props">
                {{ props.row.webhook.action.name }}
              </b-table-column>
              <!-- History ID -->
              <b-table-column label="History ID" cell-class="nowrap has-text-grey-light" width="128" v-slot="props">
                {{ props.row.id }}
              </b-table-column>
              <!-- Event ID -->
              <b-table-column label="Event ID" cell-class="nowrap has-text-grey-light" width="128" v-slot="props">
                {{ props.row.event.id }}
              </b-table-column>
              <!-- Status -->
              <b-table-column label="Status" cell-class="nowrap" width="128" centered v-slot="props">
                <p class="has-text-weight-bold">
                  <span v-if="props.row.status === 'success'" class="has-text-success">{{
                    $utils.upperFirst(props.row.status_code) }}</span>
                  <span v-else class="has-text-warning">{{ $utils.upperFirst(props.row.status_code) }}</span>
                </p>
              </b-table-column>
              <!-- Actions -->
              <b-table-column label="" cell-class="nowrap" width="128" centered v-slot="props">
                <Retry :webhook="props.row" />
              </b-table-column>
            </template>
            <template #empty>
              <div class="py-xxl has-text-grey has-text-centered">
                {{ (loading) ? "Loading data..." : 'No recent webhooks have been triggered.' }}
              </div>
            </template>
          </b-table>
          <div class="px-md pb-md">
            <b-pagination :total="total" :current.sync="currentPage" :rounded="true" :per-page="perPage"
              @change="paginate">
            </b-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Filterable from '@/mixins/Filterable'
import Retry from './Retry'
import HistoryFilters from './components/History/Filters'

export default {
  components: {
    Retry,
    HistoryFilters
  },
  data () {
    return {
      key: 'webhooks',
      topicFilter: null,
      value: null,
      results: [],
      parameter: ''
    }
  },
  computed: {
    ...mapGetters(['context']),
    endpoint () {
      return this.context.route + '/webhooks-history/'
    },
    webhooksList () {
      return this.webhookData.filter(webhook => {
        if (this.context.isMerchant()) {
          return ['retailer', 'any'].includes(webhook.partner)
        } else if (this.context.isSupplier()) {
          return ['brand', 'any'].includes(webhook.partner)
        }
        return false
      })
    }
  },
  methods: {
    applyTopicFilter (payload) {
      this.filter({
        preset: 'custom',
        search: {},
        timestamps: {},
        facets: {
          action: [{
            label: this.topicFilter,
            value: this.topicFilter
          }]
        }
      })
    }
  },
  mixins: [Filterable],
  mounted () {
    this.load()
  },
  props: []
}
</script>
